export const ACCOUNT_DETAILS = true
export const ACCOUNT_HISTORY = true
export const ACCOUNT_PASSWORD_CHANGE = true
export const ACCOUNT_PREFERENCES = true
export const DOCUMENTS = true
export const CA_SELECTION = true
export const LEG_SELECTION = true
export const QA_SELECTION = true
export const INSTRUCTION_VIDEO = true
export const DEALWATCH = true
export const PREVENT_MULTIPLE_LOGIN = false

export const LEGISLATION_TAKEOVER_CODE = false
export const LEGISLATION_KEY_PICKS = false
export const LEGISLATION_FOLDERS = true
export const LEGISLATION_PARTIAL_NOTES = true

export const ARCHIVE_FLAVOUR = true

export const AUTOMATED_PRECEDENT_LISTINGS = true
export const DOCUMENT_DRAFTER = true

// QoL project, never completed and not currently functional - disabled until
// revisited, not deleted, in case there's capacity to finish it later
export const USER_ADMIN_ENABLED = false

export const SERVICE_BANNER = true
export const TERMS_AND_CONDITIONS_BANNER = true

export const R_AND_I_ENABLED = true

// For inescapable AOL modal + Practising AoL selector in Account Preferences
export const AOL_MODAL_ENABLED = true

// New shared (non-per-AOL) email day preferences from secure/users-api/customer/email-preferences
export const SHARED_EMAIL_PREFS = true

export const NEWS_COPY_BUTTON = true
export const QA_COPY_BUTTON = true
export const QA_CASE_REF_LINKS = false
export const LEGISLATION_COPY_BUTTON = true
export const DOCUMENTS_COPY_BUTTON = true
export const DOCUMENTS_FAVOURITING = true

export const NEWS_HEADER_AOL_COLOURS = false
